<template>
<div class="chapter">
<div class="inner_page">
<p class="P_NormCenter" id="auto_bookmark_toc_3"><span><span style=" font-style: italic; font-size: 1.00em;">Dedication: To Wallace S. and all my fans.</span></span></p>
<p class="P_NormCenter"><span><span style=" font-style: italic; font-size: 1.00em;">You make all the work worthwhile.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?7824cb34